<template>
  <div class="pdl-label-group gap-1">
    <slot />
  </div>
</template>

<script>
import {PdlLabel} from '..';

export default {
  name: 'PdlLabelGroup',
  data() {
    return {
      PdlLabel,
    };
  },
};
</script>

<style lang="scss">
@import 'LabelGroup.scss';
</style>
